import { ITabConfig } from '../../../interface/ITab';
import { setEventHandlerAndScroll } from '../../util';
import {
    TAB_SWIPE_CLASS,
    TAB_WRAP_CLASS,
    TAB_LIST_CLASS,
    TAB_LIST_ITEMS_CLASS,
    ACTIVE_ITEMS_CLASS,
} from '../../constant';

export default class DepthTab {
    private config: ITabConfig;

    constructor(_config: ITabConfig) {
        this.config = _config;
        this.setDepthEvent();
        if (this.config.callbackFunc) this.setCallbackEvent();
    }
    // 활성화된 모든 탭에 스크롤 이벤트 입히기
    public setDepthEvent(): void {
        document
            .querySelectorAll<HTMLUListElement>(
                `.${TAB_WRAP_CLASS} .${TAB_LIST_CLASS}`
            )
            .forEach(($tabList) => {
                const activeIndex = Array.from(
                    $tabList.querySelectorAll(`.${TAB_LIST_ITEMS_CLASS}`)
                ).findIndex((e) => e.classList.contains(ACTIVE_ITEMS_CLASS));

                const $activatedTab = $tabList.querySelector<HTMLLIElement>(
                    `.${TAB_LIST_ITEMS_CLASS}.${ACTIVE_ITEMS_CLASS}`
                );

                if (!$activatedTab) return;
                setEventHandlerAndScroll($tabList, $activatedTab, activeIndex);
            });
    }
    // 콜백 이벤트 등록
    private setCallbackEvent(): void {
        document
            .querySelectorAll<HTMLUListElement>(`.${TAB_LIST_ITEMS_CLASS}`)
            ?.forEach((el) => {
                el.addEventListener('click', (e) => {
                    if (typeof this.config.callbackFunc !== 'function') return;
                    this.config.callbackFunc(e, {
                        depth: this.findDepth(el),
                        tabIndex: this.findClickedIndex(el),
                        href: el.children[0].getAttribute('href'),
                    });
                });
            });
    }
    private findDepth(el: HTMLUListElement): number {
        return Number(
            el.closest(`.${TAB_SWIPE_CLASS}`)!.getAttribute('data-depth') ?? ''
        );
    }
    private findClickedIndex(el: HTMLUListElement): number {
        const tablists = el
            .closest<HTMLLIElement>(`.${TAB_LIST_CLASS}`)!
            .querySelectorAll(`.${TAB_LIST_ITEMS_CLASS}`);
        return Array.from(tablists).findIndex((listItem) => listItem === el);
    }
}
